// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputPicker_wrapper__Sr3VC"};